import { useRouterWithI18n } from '@ui/locales/browserSSG';
import { useMemo } from 'react';
import { useLocation } from 'react-use';

export const normalizePathname = (pathname: string) => {
  return pathname.split('?')[0].replace(/\/$/, '').trim() || '/';
};

export const useRealPathname = () => {
  const locationState = useLocation();
  const { asPath } = useRouterWithI18n();

  /**
   * locationState.pathname will be undefined in the server side
   * but asPath will not (if we have defined the getStaticPaths for the dynamic router)
   */
  const pathname = locationState.pathname ? locationState.pathname : asPath;

  return useMemo(() => normalizePathname(pathname), [pathname]);
};
